export default "__VITE_ASSET__BKwGrDOn__"